import {useEffect} from 'react';

export function useEditorPrefetchDrawMobileModules(): void {
  useEffect((): void => {
    void prefetchDrawModeModules();
  }, []);

  const prefetchDrawModeModules = async (): Promise<void> => {
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-draw-brush-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-draw-brush-size-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-draw-brush-color-panel');
  };
}
